// Flip this in code only. Must stay false before production release..
export const SESSION_DEBUG_MODE = false;

export const DEBUG_SIGNIN_SESSION_KEY = 'zd_debug_signin_session_raw';
